module.exports = ".pwd-disabled {\n    background-color: #EEE;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/accounts/edit/update-smtp/update-smtp.component.css
// module id = ./src/app/agora/components/account-data/accounts/edit/update-smtp/update-smtp.component.css
// module chunks = main